module.exports = __webpack_public_path__ + "img/settingsExecutionIcon.41af0ad2.svg";